import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import ArrowButton from './ButtonArrow';

const EntryIcons = ({
  attributes,
  exerType,
  isHealthEntry,
  isMainWorkoutEntry,
  isNoteEntry,
  modalOpen,
}) => (
  <div className={`entry_icons ${exerType === 'note' ? 'note_icons' : ''}`}>
    {isMainWorkoutEntry && (
      <ArrowButton
        handleArrowClick={modalOpen}
        dataFirst='opt-out'
        icon='opt-out'
      />
    )}
    {!isNoteEntry && (
      <ArrowButton
        handleArrowClick={modalOpen}
        dataFirst='note'
        icon='note'
      />
    )}
    {!isHealthEntry && (
      <Fragment>
        {attributes.doc !== null && (
          <ArrowButton
            handleArrowClick={modalOpen}
            dataFirst='attachment'
            icon='attachment'
          />
        )}
        {attributes.video ? (
          <ArrowButton
            handleArrowClick={modalOpen}
            dataFirst='video'
            icon='video'
          />
        ) : ''}
        {attributes.instruction && (
          <Fragment>
            {attributes.instruction !== '' && (
              <ArrowButton
                handleArrowClick={modalOpen}
                dataFirst='info'
                icon='info'
              />
            )}
          </Fragment>
        )}
      </Fragment>
    )}

    {(isMainWorkoutEntry || isHealthEntry) && (
      <ArrowButton
        handleArrowClick={modalOpen}
        dataFirst='history'
        icon='clock'
      />
    )}
  </div>
);

EntryIcons.propTypes = {
  attributes: PropTypes.instanceOf(Object).isRequired,
  exerType: PropTypes.string.isRequired,
  isHealthEntry: PropTypes.bool.isRequired,
  isMainWorkoutEntry: PropTypes.bool,
  isNoteEntry: PropTypes.bool.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

EntryIcons.defaultProps = {
  isMainWorkoutEntry: false,
};

export default memo(EntryIcons);
